import React from 'react';
import { FileSearch } from 'lucide-react';

export function EmptyState({ title = 'Belum ada data', description = '', action = null, icon: Icon = FileSearch }) {
  return (
    <div data-testid="empty-state" className="flex flex-col items-center justify-center text-center py-12 px-6 border border-dashed border-slate-200 rounded-xl bg-slate-50/40">
      <div className="w-14 h-14 rounded-full bg-white border border-slate-200 flex items-center justify-center mb-3 shadow-premium">
        <Icon className="w-6 h-6 text-slate-400" />
      </div>
      <h4 className="text-base font-semibold text-slate-700">{title}</h4>
      {description && <p className="text-sm text-slate-500 mt-1 max-w-md">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
